import { makeStyles } from '@material-ui/core/styles';

const styles = makeStyles(theme => ({
  dialogContainer: {
    background: '#F4F4F4'
  },
  title: {
    marginLeft: theme.spacing(2),
    flex: 1
  },
  container: {
    display: 'block',
    background: '#F4F4F4',
    height: '100%'
  },
  topContainer: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'flex-end',
    paddingLeft: 104,
    paddingTop: 83,
    paddingRight: 109
  },
  bottomContainer: {
    display: 'flex',
    flexDirection: 'column',
    // alignItems: 'flex-start',
    marginTop: 83,
    marginLeft: 104,
    width: 478,
    justifyContent: 'flex-start'
  },
  subStageContainer: {
    paddingLeft: 22,
    marginTop: 26
  },
  topLeft: {
    display: 'block'
  },
  topRight: {
    display: 'flex',
    width: 364,
    alignItems: 'space-between',
    justifyContent: 'space-between'
  },
  button: {
    width: 178,
    height: 48,
    fontFamily: 'Roboto-Regular',
    fontSize: '14px',
    color: '#FFFFFF',
    letterSpacing: '0.25px',
    textAlign: 'left',
    lineHeight: '20px',
    padding: 0,
    paddingLeft: 16
  }
}));

export default styles;
